var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLayers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    d: "M0 0l24 0 0 24L0 24Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.93 16.07l6.42-5.12 .15-.13c.64-.52.75-1.46.24-2.11 -.08-.09-.16-.18-.25-.25L12.9 3.22c-.55-.44-1.33-.44-1.87 0l-6.6 5.24c-.65.51-.76 1.45-.25 2.1 .07.08.15.16.23.23l.15.12 6.43 5.11c.54.43 1.32.43 1.86-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    d: "M11.05 18.67l-5.73-4.55c-.4-.32-.96-.25-1.27.14 -.01 0-.01 0-.01 0v0c-.31.39-.24.96.16 1.27 0 0 0 0 0 0l6.86 5.24c.53.41 1.28.41 1.82 0l6.85-5.25c.4-.31.47-.89.17-1.29 -.01-.01-.01-.01-.01-.01v0c-.31-.4-.89-.47-1.28-.17 -.01 0-.01 0-.01 0l-5.73 4.55c-.55.43-1.33.43-1.87 0Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayers);
export default __webpack_public_path__ + "static/media/layers.bb6dc8e0.svg";
export { ForwardRef as ReactComponent };